import React from "react"

const ActionMessage = ({ deletable, notDeletable }) => {
  const del = deletable && deletable.length
  const notDel = notDeletable && notDeletable.length
  return (
    <p className="text-muted">
      {notDel > 0 && (
        <span>
          <span className="font-600"> {notDel} </span>
          {notDel === 1 ? "Schedule is" : "Schedules are"} not deletable since{" "}
          {notDel === 1 ? "it is" : "they are"} live.
        </span>
      )}{" "}
      Are you sure you want to delete <span className="font-600">{del}</span>{" "}
      {del === 1 ? "Schedule" : "Schedules"} ?
    </p>
  )
}

export default ActionMessage
